import dayjs from 'dayjs';
import { yearlyFormat } from './Date';
import { isValidHrsAndMinutesFormat } from './RegExp';
import { DEPARTMENT_SLUGS, DESIGNATION_SLUGS, leaveTypeList } from '../constants/common';
import moment from 'moment';

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0;

// ** Returns K format from a number
export const kFormatter = (num) => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num);

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, '');

export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === 'admin') return '/';
  if (userRole === 'client') return '/access-control';
  return '/login';
};

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed', // for input hover border-color
  },
});

export const capitalizeFirstLetter = (string) => {
  if (!string || typeof string !== 'string') return string;
  return string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase();
};

export const capitalizeEachFirstLetter = (str) => {
  if (typeof str !== 'string') return str;
  // Replace underscores with spaces, then capitalize each word
  return str.replace(/_/g, ' ').replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => (m1 ? m1.toUpperCase() : '') + (m2 ? m2.toLowerCase() : ''));
};

export const isNumber = (char) => {
  return !isNaN(parseInt(char?.trim()));
};

export const objectKeysLength = (object) => {
  if (object && typeof object === 'object') {
    Object.keys(object).length;
  } else {
    return 0;
  }
};

export const selectCustomsStyles = (theme) => {
  return {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
      ...base,
      minHeight: 35,
      background: theme === 'light' ? 'white' : '#283046',
    }),
    option: (base, { data, isDisabled, isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isDisabled ? undefined : isFocused ? (theme === 'dark' ? 'rgba(135, 230, 75, 0.35)' : 'rgba(135, 230, 75, 0.2)') : undefined,
      color: theme === 'dark' ? 'white' : 'hsl(0, 0%, 50%)',
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      background: theme === 'light' ? 'white' : '#283046',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme === 'light' ? 'black' : 'hsl(0, 0%, 50%',
    }),
    input: (provided) => ({
      ...provided,
      color: theme === 'light' ? 'black' : 'white',
    }),
  };
};

export const getFirstAndLastInitials = (name) => {
  if (!name) return;
  let fullName = name?.split(' '),
    initials = fullName[0]?.substring(0, 1)?.toUpperCase();
  if (fullName?.length > 1) {
    initials += fullName[fullName?.length - 1]?.substring(0, 1)?.toUpperCase();
  }
  return initials;
};

export const tableSerialNumberColumn = (pageNo = 1, pageLimit = 10) => {
  return (text, record, index) => <span>{(pageNo - 1) * pageLimit + index + 1}</span>;
};

export const trimString = (string) => {
  return string.trim();
};

export const deepClone = (object) => {
  return JSON.parse(JSON.stringify(object));
};

/**
 * This function is used to add the missing permissions upon save
 */
export function verifyMissingPermissions(allPermissions, permissionsToSubmit) {
  for (let permission in allPermissions) {
    if (!permissionsToSubmit.hasOwnProperty(permission)) permissionsToSubmit[permission] = allPermissions[permission];
  }

  return permissionsToSubmit;
}
export function persistColumnsName(selectedColumns = [], component = '') {
  const columns = localStorage.getItem('hideColumns');
  if (!columns) localStorage.setItem('hideColumns', JSON.stringify({}));
  const savedColumns = JSON.parse(localStorage.getItem('hideColumns'));
  savedColumns[component] = selectedColumns;
  localStorage.setItem('hideColumns', JSON.stringify(savedColumns));
}
// Parameter => Employees : []
//return Project Manager Object or undefined (if PM not includes in parameter array)
export const extractProjectManager = (resources = []) => {
  return resources.find((resource) => {
    const workAsManager = resource.EmployeeProject?.role_id === 3;
    // const isManagerDesignation = resource.designation?.toLowerCase().includes('project manager');
    return workAsManager ? true : false;
  });
};
//SORT ARRAY OF OBJECTS
//parameters: sort: string (ASC || DESC ), property : string, data : []
export const sortObjectsArray = (sort = 'ASC', property = '', data = []) => {
  if (sort === 'ASC') {
    return data.sort((a, b) => {
      if (a[property] < b[property]) {
        return -1;
      }
      if (a[property] > b[property]) {
        return 1;
      }
      return 0;
    });
  } else {
    return data.sort((a, b) => {
      if (b[property] < a[property]) {
        return -1;
      }
      if (b[property] > a[property]) {
        return 1;
      }
      return 0;
    });
  }
};

export const customFilter = (option, searchText) => {
  let op = ' ';
  if (searchText.match(/\s/g)) {
    op = ',';
  }
  const searchName = option.data.label.split(op);
  if (
    (searchName[0] && searchName[0].toLowerCase().startsWith(searchText.toLowerCase())) ||
    (searchName[1] && searchName[1].toLowerCase().startsWith(searchText.toLowerCase())) ||
    (searchName[2] && searchName[2].toLowerCase().startsWith(searchText.toLowerCase()))
  ) {
    return true;
  } else {
    return false;
  }
};

export const truncateWords = (sentence, amount, tail, sentenceLength = 30) => {
  if (sentence?.length > sentenceLength) {
    return sentence.substring(0, amount) + tail;
  }
  return sentence;
};

// Count engagement availability of employees
export const countEngagementAvailability = (capacity) => {
  const totalHoursOfAverageDay = 8;
  if (!isNaN(capacity)) return +(+capacity / totalHoursOfAverageDay).toFixed(2);
  return 0;
};

export const setHrsAndMiutesFormat = (value) => {
  if (value) {
    const arr = value.split(':');
    if (arr.length === 2) {
      if (arr[0].length === 1) {
        arr[0] = `0${arr[0]}`;
      }
      if (arr[1].length === 1) {
        arr[1] = `0${arr[1]}`;
      }

      value = `${arr[0]}:${arr[1]}`;
    }
  }
  return value;
};

export const convertMinutesToHM = (minutes) => {
  return setHrsAndMiutesFormat(`${Math.floor(minutes / 60)}:${minutes % 60}`);
};

export function convertHMToMinutes(timeString) {
  const [hours, minutes] = timeString.split(':').map(Number);
  return hours * 60 + minutes;
}

export const countTotalSelectedDayTime = (overTimeClaim, selectedDate, totalClaimedMinutes = 0) => {
  overTimeClaim?.forEach((item) => {
    if (item?.claimHours) {
      if (dayjs(selectedDate).isSame(item?.date, 'day')) totalClaimedMinutes += convertHMToMinutes(item?.claimHours);
    }
  });
  return totalClaimedMinutes;
};

export const getCurrentWeek = async (dateValue) => {
  const selectedDate = moment(dateValue);
  const monthStartDate = selectedDate.clone().startOf('month');
  const monthEndDate = selectedDate.clone().endOf('month');

  let startWeekDate = selectedDate.clone().startOf('isoWeek');
  let endWeekDate = selectedDate.clone().endOf('isoWeek');

  if (startWeekDate.isBefore(monthStartDate)) startWeekDate = monthStartDate;
  if (endWeekDate.isAfter(monthEndDate)) endWeekDate = monthEndDate;

  startWeekDate = yearlyFormat(startWeekDate.toDate());
  endWeekDate = yearlyFormat(endWeekDate.toDate());

  return { startWeekDate, endWeekDate };
};

const calculateLastStartAndEndDate = (days) => {
  const startDate = dayjs()
    .subtract(days - 1, 'days')
    .startOf('day')
    .format('YYYY-MM-DD');
    const endDate = dayjs().endOf('day').format('YYYY-MM-DD');
  return { startDate, endDate };
};

export const getLastStartAndEndDate = (key) => {
  let lastDays;

  switch (key) {
    case 'last_2_weeks':
      lastDays = 14;
      break;
    case 'last_month':
      lastDays = 30;
      break;
    case 'last_3_months':
      lastDays = 90;
      break;
    case 'last_6_months':
      lastDays = 180;
      break;
    case 'last_9_months':
      lastDays = 270;
      break;
    case 'last_12_months':
      lastDays = 360;
      break;

    default:
      lastDays = 1;
      break;
  }

  return calculateLastStartAndEndDate(lastDays);
};

export const convertCityNames = (slug) => {
  let name;

  switch (slug) {
    case 'lhr':
      name = 'Lahore';
      break;
    case 'fsd':
      name = 'Faisalabad';
      break;
    case 'isb':
      name = 'Islamabad';
      break;
    case 'khi':
      name = 'Karachi';
      break;
    case 'rmte':
      name = 'Remote';
      break;
    default:
      name = 'N/A';
      break;
  }

  return name;
};

export const hasUndefinedOrNull = (str) => {
  return str.includes('undefined') || str.includes('null');
};

export const getDesignation = (employee) => {
  return employee?.myDesignation?.name
    ? `${employee?.designationLevel?.name && employee?.designationLevel?.name.toLowerCase() !== 'n/a' ? `${employee?.designationLevel?.name} ` : ''}${
        employee?.myDesignation?.name
      }`
    : employee?.designation;
};

export const geExtFromPath = (path) => {
  return path
    ? path
        .split('.')
        .filter((part) => !!part)
        .at(-1)
    : '';
};

export const geNameFromPath = (path) => {
  if (!path) return '';

  const nameWithExtension = path
    .split('/')
    .filter((part) => !!part)
    .at(-1);
  const name = nameWithExtension.substring(0, nameWithExtension.lastIndexOf('.'));
  return name;
};

export const isImage = (path) => {
  if (!path) return '';

  const extension = geExtFromPath(path);
  const result = ['jpg', 'jpeg', 'png'].includes(extension);
  return result;
};

export const isDesignationCheck = (employee, type) => {
  let result = false;

  switch (type) {
    case DESIGNATION_SLUGS.PROJECT_MANAGER:
      result = employee?.myDesignation?.slug === DESIGNATION_SLUGS.PROJECT_MANAGER;
      break;
    case DESIGNATION_SLUGS.CEO:
      result = employee?.myDesignation?.slug === DESIGNATION_SLUGS.CEO;
      break;
    case DESIGNATION_SLUGS.SQA:
      result = employee?.myDesignation?.slug === DESIGNATION_SLUGS.SQA;
      break;
  }

  return result;
};

export const isDepartmentCheck = (employee, type) => {
  let result = false;

  switch (type) {
    case DEPARTMENT_SLUGS.HR:
      result = employee?.myDepartment?.slug === DEPARTMENT_SLUGS.HR;
      break;
    case DEPARTMENT_SLUGS.BO:
      result = employee?.myDepartment?.slug === DEPARTMENT_SLUGS.BO;
      break;
    case DEPARTMENT_SLUGS.SALES:
      const sales = [
        DEPARTMENT_SLUGS.BD_CORPORATE,
        DEPARTMENT_SLUGS.BD_DYNAMIC,
        DEPARTMENT_SLUGS.BD_EXECUTIVE,
        DEPARTMENT_SLUGS.BD_FAST_SALES,
        DEPARTMENT_SLUGS.SALES,
      ];
      result = sales.includes(employee?.myDepartment?.slug);
      break;
  }

  return result;
};

export const isDateWithin12Days = (dateString) => {
  // Convert dateString to a Date object
  const date = new Date(dateString);

  // Get the current date
  const currentDate = new Date();

  // Calculate the difference in milliseconds
  const difference = currentDate - date;

  // Convert milliseconds to days
  const differenceInDays = difference / (1000 * 3600 * 24);

  // Check if the difference is less than 12 days
  return differenceInDays < 12;
};

/**
 * Determines if the leave is enabled based on the selected leave type and remaining leaves.
 * @param {string} selectedLeaveType - The leave type selected by the employee (CASUAL or SICK).
 * @param {number} remainingCasualLeaves - The number of remaining casual leaves.
 * @param {number} remainingSickLeaves - The number of remaining sick leaves.
 * @returns {boolean} - Whether the leave is enabled based on the remaining leaves.
 */
export const isLeaveEnabled = (selectedLeaveType, remainingCasualLeaves, remainingSickLeaves) => {
  if (remainingSickLeaves > 0.25 || remainingCasualLeaves > 0.25) return true;
  else return false; // Invalid leave type
};

/** Adds a new leave type to the leaveTypes array.
 * @param {Array} leaveTypes - The array of leave types to add to.
 * @param {string} value - The value of the new leave type.
 * @param {string} label - The label of the new leave type.
 */
const addLeaveType = (leaveTypes, value, label) => {
  leaveTypes.splice(0, 0, { value, label });
};

/**
 * Determines whether to add a leave type based on remaining leaves and filter condition.
 * @param {number} remainingLeaves - The number of remaining leaves.
 * @param {boolean} filter - The filter condition.
 * @returns {boolean} - Whether to add the leave type.
 */
const shouldAddLeaveType = (remainingLeaves, filter) => {
  return remainingLeaves > 0 || filter;
};

/**
 * Processes a leave type based on earned and availed leaves, and adds it to the leaveTypes array if necessary.
 * @param {Array} leaveTypes - The array of leave types to add to.
 * @param {number} earnedLeaves - The number of earned leaves.
 * @param {number} availedLeaves - The number of availed leaves.
 * @param {string} type - The type of leave.
 * @param {string} typeLabel - The label of the leave type.
 * @param {boolean} filter - The filter condition.
 */
const processLeaveType = (leaveTypes, earnedLeaves, availedLeaves, type, typeLabel, filter) => {
  const remainingLeaves = earnedLeaves - availedLeaves;
  if (shouldAddLeaveType(remainingLeaves, filter)) {
    addLeaveType(leaveTypes, type, typeLabel);
  }
};

/**
 * Processes leave information and updates the leaveTypes array accordingly.
 * @param {Object} employeeLeavesInfo - Information about the employee's leaves.
 * @param {Array} leaveTypes - The array of leave types to update.
 * @param {Object} info - Information about the specific leave type.
 * @param {boolean} filter - The filter condition.
 */
const processLeaveInfo = (employeeLeavesInfo, leaveTypes, info, filter) => {
  const { earned, availed, type, name } = info;
  if (employeeLeavesInfo[earned] != null && employeeLeavesInfo[availed] != null) {
    processLeaveType(leaveTypes, employeeLeavesInfo[earned], employeeLeavesInfo[availed], type, name, filter);
  }
};

/**
 * Filters and returns the leave types based on job status, employee leaves information, and filter condition.
 * @param {string} jobStatus - The job status of the employee.
 * @param {Object} employeeLeavesInfo - Information about the employee's leaves.
 * @param {boolean} filter - The filter condition.
 * @returns {Array} - The filtered leave types array.
 */
export const filteredLeaveTypes = (jobStatus, employeeLeavesInfo, filter) => {
  let leaveTypes = [...leaveTypeList.slice(-1)];

  if (employeeLeavesInfo && jobStatus) {
    const leaveInfoMap = {
      Internship: { earned: 'internshipPeriodLeavesEarned', availed: 'availedInternshipLeaves', type: 'INTERNSHIP', name: 'Internship Leave' },
      Probation: { earned: 'probationPeriodLeavesEarned', availed: 'availedProbationPeriodLeaves', type: 'PROBATION', name: 'Probation Leave' },
      'Notice Period': {
        earned: 'noticePeriodLeavesEarned',
        availed: 'noticePeriodLeavesAvailed',
        type: 'NOTICE_PERIOD',
        name: 'Notice Period Leave',
      },
      default: [
        { earned: 'carryForwardedLeaves', availed: 'availedCarryForwardLeaves', type: 'CARRY_FORWARD', name: 'Carry Forward Leave' },
        { earned: 'sickLeavesEarned', availed: 'sickLeavesAvailed', type: 'SICK', name: 'Sick Leave' },
        { earned: 'casualLeavesEarned', availed: 'casualLeavesAvailed', type: 'CASUAL', name: 'Casual Leave' },
        ...(jobStatus === 'Permanent' & employeeLeavesInfo['internshipPeriodLeavesEarned'] > 0 ? [{ earned: 'internshipPeriodLeavesEarned', availed: 'availedInternshipLeaves', type: 'INTERNSHIP', name: 'Internship Leave' }] : []),
        ...(jobStatus === 'Permanent' & employeeLeavesInfo['probationPeriodLeavesEarned'] > 0 ? [{ earned: 'probationPeriodLeavesEarned', availed: 'availedProbationPeriodLeaves', type: 'PROBATION', name: 'Probation Leave' }] : []),
      ],
    };

    const leaveInfo = leaveInfoMap[jobStatus] || leaveInfoMap['default'];
    if (Array.isArray(leaveInfo)) {
      leaveInfo.forEach((info) => {
        processLeaveInfo(employeeLeavesInfo, leaveTypes, info, filter);
      });
    } else {
      processLeaveInfo(employeeLeavesInfo, leaveTypes, leaveInfo, filter);
    }
  }

  return leaveTypes;
};

/**
 * Converts a string to title case (capitalizes the first letter of each word).
 * @param {string} inputString - The input string to convert to title case.
 * @returns {string} - The input string converted to title case.
 */
export const convertToTitleCase = (inputString) => {
  // Capitalize the first letter of the first word
  let firstWord = inputString?.charAt(0)?.toUpperCase() + inputString?.slice(1)?.toLowerCase();
  if (firstWord) return firstWord?.replace('_', ' ');
};

export const uniqueItemsArray = (array, identifier) => {
  const uniqueLabels = [];
  const uniqueArray = [];

  array.forEach((item) => {
    if (!uniqueLabels?.includes(item[identifier]?.toString()?.trim())) {
      uniqueLabels?.push(item[identifier]?.toString()?.trim());
      uniqueArray?.push(item);
    }
  });

  return uniqueArray;
};

export const validateInput = (key, value) => {
  switch (key) {
    case 'fatherName':
      if (value.length > 100) return 'Only 100 characters are allowed';
      break;
    case 'address':
    case 'bankAddress':
      if (value.length > 300) return 'Only 300 characters are allowed';
      break;
    case 'cnic':
      if (/[^0-9]/.test(value)) return 'Only numbers are allowed!';
      if (value.length > 15) return 'Only 15 characters are allowed';
      break;
    case 'emergencyContactNumber':
      if (/[^0-9]/.test(value)) return 'Only numbers are allowed!';
      if (value.length > 15) return 'Only 15 characters are allowed';
      break;
    case 'accountTitle':
    case 'ibanNumber':
    case 'fieldOfStudy':
    case 'school':
    case 'emergencyContactName':
      if (value.length > 50) return 'Only 50 characters are allowed';
      break;
    case 'bankTitle':
      if (value.length > 40) return 'Only 40 characters are allowed';
      break;
    case 'scorePercentage':
      const floatInputValue = parseFloat(value);
      if (isNaN(floatInputValue) || floatInputValue > 100) return 'Please enter a number between 0 and 100';
      if (value.length > 15) return 'Only 15 characters are allowed.';
      break;
    default:
      return '';
  }
  return '';
};


// months (0 to 11) where 0 is january and 11 is december
export const isJanuary = () => dayjs().month() === 0;

export const isPermanentEmployee = (job_status) => {
  if(!job_status) return false;
  return  !['Internship', 'Probation', 'Notice Period'].includes(job_status)
}

export const employeeOnNoticePeriod = (job_status) => {
  if(!job_status) return false;
  return  job_status === 'Notice Period'
}

